import { useMemo, useState } from "react";
import { PageHero } from "@/components/site/PageHero";
import { CourseRow, useCourses } from "@/components/home/ProgrammesPreview";

export default function Programmes() {
  const courses = useCourses();
  const [cat, setCat] = useState("All");
  const cats = useMemo(() => ["All", ...new Set(courses.map((c) => c.category))], [courses]);
  const shown = cat === "All" ? courses : courses.filter((c) => c.category === cat);
  return (
    <main>
      <PageHero
        eyebrow="Training programmes"
        lines={["Learn on", <span key="c" className="italic text-ochre">Country.</span>]}
        intro="Free-to-browse programmes in culture, caring for Country, leadership and employment. Create an account to enrol."
        image="/img/cliffs.jpg"
      />
      <section className="bg-sand px-5 py-20 text-ink sm:px-10">
        <div className="mx-auto max-w-[1440px]">
          <div className="mb-10 flex flex-wrap gap-3">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`rounded-full border px-5 py-2 text-sm transition-colors duration-300 ${cat === c ? "border-ink bg-ink text-sand" : "border-ink/25 hover:border-ink"}`}
              >
                {c}
              </button>
            ))}
          </div>
          {shown.map((c, i) => <CourseRow key={c.slug} c={c} i={i} />)}
          {!courses.length && <p className="py-20 text-ink/70">Programmes are loading or unavailable right now.</p>}
        </div>
      </section>
    </main>
  );
}
